export default __webpack_public_path__ + "static/hire-dedicated-mobile-web-developers-team-peerbits-501c2cb1fa64b925b454e602c9044e09.png";